import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ReleaseElectoralCardSearchPersonCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca Persona - Tessera Elettorale',
    path: '/sportello/tessera-elettorale',
  },
];

export const ReleaseElectoralCardCrumbs = [
  ...ReleaseElectoralCardSearchPersonCrumbs,
  {
    name: 'Rilascio Tessera Elettorale',
    path: '/sportello/tessera-elettorale/rilascio',
  },
];
